import React from "react";
import { Button, Typography } from "antd";
import { useTranslation } from "react-i18next";

import EditIcon from "../assets/svg/EditIcon";

const { Text } = Typography;

const EditButton = ({ disabled, onClick }) => {
  const { t } = useTranslation();
  return (
    <Button disabled={disabled} type="text" onClick={onClick} data-tm-id="cct-status-btn">
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <EditIcon />
        <Text style={{ color: "#2B56A3", paddingLeft: 3 }}>{t("edit")}</Text>
      </div>
    </Button>
  );
};

export { EditButton };
